import AXIOS from "./axios";

export class PreLaunch {
  // Endpoint público: responde mesmo sem token e, quando há token nos headers,
  // já diz se o usuário logado está no snapshot de testers.
  static status() {
    return AXIOS.get("/pre_launch");
  }
}
